import { TextField } from '@refinedev/antd';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';

interface ServiceOrderShowBillingProps {
  serviceOrder: any;
}

const ServiceOrderShowBilling = (props: ServiceOrderShowBillingProps) => {
  const { t } = useTranslation();
  const { serviceOrder } = props;
  const formatBoolean = (value?: boolean) =>
    value === undefined || value === null ? '-' : value ? t('Sí') : t('No');
  const formatWithSuffix = (value: number | string | null | undefined, suffix: string) => {
    if (value === undefined || value === null || value === '') {
      return '-';
    }

    return `${value} ${suffix}`;
  };

  return (
    <Card className="ServiceOrderShowSection">
      <div className="ServiceOrderShowTitle">{t('Detalles de la facturación')}</div>
      <div className="ServiceOrderShowDataCard">
        <div className="ServiceOrderShowData">
          <b>{t('Precio por hora')}</b>
          <div>
            <TextField
              value={formatWithSuffix(
                serviceOrder.hourly_rate,
                `${serviceOrder.currency?.simbolo}/hs`,
              )}
            />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Precio por kilómetro')}</b>
          <div>
            <TextField
              value={formatWithSuffix(
                serviceOrder.kilometres_rate,
                `${serviceOrder.currency?.simbolo}/km`,
              )}
            />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Horas')}</b>
          <div>
            <TextField value={formatWithSuffix(serviceOrder.hours_estimated, 'hs')} />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Kilómetros recorridos')}</b>
          <div>
            <TextField value={formatWithSuffix(serviceOrder.kilometres_estimated, 'km')} />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Pagar servicio al técnico')}</b>
          <div>
            <TextField value={formatBoolean(serviceOrder.technician_pay)} />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Facturar al cliente')}</b>
          <div>
            <TextField value={formatBoolean(serviceOrder.customer_invoice)} />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Horas cubiertas por Acronex')}</b>
          <div>
            <TextField value={formatWithSuffix(serviceOrder.hours_covered, 'hs')} />
          </div>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Kilómetros cubiertos por Acronex')}</b>
          <div>
            <TextField value={formatWithSuffix(serviceOrder.kilometres_covered, 'km')} />
          </div>
        </div>
      </div>
      <div className="ServiceOrderShowData" style={{ marginTop: 16 }}>
        <b>{t('Comentarios / Gastos adicionales')}</b>
        <div>
          <TextField value={serviceOrder.aditional_comment ?? '-'} />
        </div>
      </div>
    </Card>
  );
};

export default ServiceOrderShowBilling;
